import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class AccountBillingCancellationFlowPopupReactivateComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('flow/cancellation') declare flowCancellationService: Service.Flow.Cancellation;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('request') declare requestService: Service.Request;

	@tracked isReactivated = false;

	@action
	reactivate(): void {
		this.submitInProgress = true;

		this.flowCancellationService
			.reactivateSubscription()
			.then(() => {
				this.isReactivated = true;
			})
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
	}

	@action
	editSubscription(): void {
		this.navigationService.transitionToRoute('settings.billing.plans');
		this.close();
	}
	<template>
		<div class="content">

			{{#if this.isReactivated}}

				<img src="/images/svg/circle-check-green.svg" height="145" alt />
				<h2>Your subscription has been successfully re-activated!</h2>
				<p>
					Your current subscription plan is
					<strong>{{this.billingService.activePlan.name}}</strong>
					with a
					<strong>{{this.billingService.activePlan.billingCycleTextLong}}</strong>
					billing cycle ({{this.billingService.subscription.discountAmountFormatted}}/m).
					<br />
					Check the billing page for more information.
				</p>

				<div class="controls2 controls2--center">
					<SubmitButtonComponent
						@text="Close"
						@size="big"
						@theme="grey-outlined"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
				</div>

			{{else}}

				<img src="/images/svg/circle-pause-orange.svg" height="145" alt />

				{{#if this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins}}

					<h2>Your data sync is paused</h2>
					<p>To re-activate the data sync please contact your account owner.</p>

				{{else}}

					<h2>You subscription is paused</h2>

					{{#if this.currentUserService.isOwner}}

						<p>
							Your subscription is paused until
							<strong>{{this.billingService.formattedActiveUntil}}</strong>.
							<br />
							Re-activate anytime to continue using Databox.
						</p>

						<div class="controls2 controls2--center">
							<SubmitButtonComponent
								@text="Re-activate"
								@size="big"
								@noDelay={{true}}
								@submitInProgress={{this.submitInProgress}}
								@onTrigger={{this.reactivate}}
								@icon="Refresh"
							/>
							<SubmitButtonComponent
								@text="Edit subscription"
								@theme="grey-empty"
								@onTrigger={{this.editSubscription}}
							/>
						</div>

					{{else}}

						<p>
							To re-activate the subscription and continue where you left off,
							<br />
							please contact your account owner.
						</p>

					{{/if}}

				{{/if}}

			{{/if}}

		</div>
	</template>
}
